/**
 * Derive the WebRTC (WHEP) endpoint for a stream from its HLS URL.
 *
 * The stream registry hands the COP HLS URLs shaped
 *   https://prod.shovron.com/streams/<path>/index.m3u8
 * where <path> is the MediaMTX mount (e.g. `live/drone-<id>`,
 * `dock-050cfddf/cam1`). MediaMTX serves the same mount over WHEP at
 *   /webrtc/<path>/whep
 * (nginx proxies /webrtc/ -> :8889 the same way /streams/ -> :8888).
 *
 * Derived client-side rather than adding a second URL to the registry: the two
 * URLs are the same mount by construction, so carrying both invites them to
 * drift apart.
 *
 * Returns null for anything that is not that shape — an .mp4 recording, a
 * relative URL, an external stream — which the player reads as "no WHEP,
 * use HLS directly".
 */
export function whepUrlFromStreamUrl(streamUrl: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(streamUrl);
  } catch {
    return null;
  }
  const match = parsed.pathname.match(/^\/streams\/(.+)\/index\.m3u8$/);
  if (!match) return null;
  return `${parsed.origin}/webrtc/${match[1]}/whep`;
}
